var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "v-collapse border-b", class: { disabled: _vm.isDisabled } },
    [
      _c(
        "div",
        {
          staticClass: "v-collapse__header",
          class: { "is-active": _vm.isActive },
          on: {
            click: function ($event) {
              return _vm.change(!_vm.isActive)
            },
          },
        },
        [
          _vm.$slots.title
            ? _vm._t("title")
            : [_vm._v(" " + _vm._s(_vm.title) + " ")],
          _c("i", {
            staticClass: "v-collapse__arrow v-icon-down",
            class: { "is-active": _vm.isActive },
          }),
        ],
        2
      ),
      _c("collapse-transition", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isActive,
                expression: "isActive",
              },
            ],
            staticClass: "v-collapse__item",
          },
          [
            _c(
              "div",
              { staticClass: "v-collapse__item__content" },
              [
                _vm._t("default", function () {
                  return [_vm._v(_vm._s(_vm.text))]
                }),
              ],
              2
            ),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }